<template>
    <div>
        <v-layout row class="mt-3 ml-4 mb-0" justify-space-between>
            <!-- <v-btn-toggle
                class="appointments-mode-toggle-button-group"
                mandatory
                v-model="viewMode"
            >
                <v-btn
                    class="appointments-mode-toggle-button"
                    flat
                    value="list"
                >
                    List View
                </v-btn>
                <v-btn
                    class="appointments-mode-toggle-button"
                    flat
                    value="calendar"
                >
                    Calendar View
                </v-btn>
            </v-btn-toggle> -->

            <v-radio-group v-model="viewMode" row class="my-0" hide-details>
                <v-radio
                    label="Calendar View"
                    value="calendar"
                    color="success"
                ></v-radio>
                <v-radio
                    label="List View"
                    value="list"
                    color="success"
                ></v-radio>
            </v-radio-group>

            <v-btn color="success" class="mr-2 my-0" small @click="addSlots"
                >Add Appointment Slots</v-btn
            >
            <v-btn
                color="success"
                class="mr-3 my-0"
                small
                v-if="allowChangingAppointment()"
                @click="openBlockedDatesDialog"
                >Blocked Dates</v-btn
            >

            <v-select
                style="max-width: 250px;"
                label="Branch"
                v-model="createAppointment.branch"
                :items="createAppointment.branches"
                class="mr-4 pt-0"
                hide-details
                @change="branchChanged"
                ref="branch"
                :rules="[rules.required]"
                :disabled="hasUserBranch()"
            >
            </v-select>
            <v-select
                style="max-width: 250px;"
                label="Term"
                v-model="regID"
                :items="terms"
                class="mr-4 pt-0"
                hide-details
                @change="regIDChanged"
                ref="regID"
                :rules="[rules.required]"
            >
            </v-select>
        </v-layout>
        <dx-grid
            v-if="viewMode == 'list'"
            :url="listURL"
            :columns="columns"
            :actions="actions"
            :title="title"
            :selectionEnabled="true"
            :onCellPrepared="onGridCellPrepared"
            ref="grid"
        ></dx-grid>
        <div v-if="viewMode == 'calendar'">
            <v-layout row justify-space-between class="mx-4 mt-2">
                <v-btn
                    style="background-color: #fff !important;"
                    color="success"
                    outline
                    @click="$refs.calendar.prev()"
                >
                    <v-icon left>
                        mdi-chevron-left
                    </v-icon>
                    Prev
                </v-btn>

                <div class="pt-4 headline">
                    {{ getCurrentMonth() }}
                </div>

                <v-btn
                    style="background-color: #fff !important;"
                    color="success"
                    outline
                    @click="$refs.calendar.next()"
                >
                    Next
                    <v-icon dark>
                        mdi-chevron-right
                    </v-icon>
                </v-btn>
            </v-layout>
            <v-flex xs12 class="mx-4">
                <v-sheet>
                    <v-calendar
                        style="border: 2px solid #5cb860;"
                        v-model="start"
                        :end="end"
                        color="primary"
                        class=""
                        ref="calendar"
                        :min-weeks="createAppointment.minWeeks"
                    >
                        <template v-slot:day="{ date }">
                            <div
                                class="heb-date text--disabled"
                                v-bind:class="{
                                    'left-68': isFirstOfMonth(date),
                                }"
                            >
                                {{ getDateInfo(date) }}
                            </div>
                            <v-btn
                                class="add-slots-button"
                                small
                                icon
                                v-if="allowedDates(date)"
                                @click="addSlotsFromCalendar(date)"
                                ><v-icon dark color="success"
                                    >mdi-plus-circle</v-icon
                                ></v-btn
                            >
                            <template
                                v-if="existingEventsMap[date].length"
                                v-for="event in existingEventsMap[date]"
                            >
                                <v-menu
                                    :key="event.title"
                                    v-model="event.open"
                                    full-width
                                    offset-x
                                >
                                    <template v-slot:activator="{ on }">
                                        <div
                                            v-ripple
                                            class="slot-event slot-event-clickable"
                                            v-bind:class="{
                                                'slot-event-assigned-class':
                                                    event.studentID &&
                                                    hasClass(event.section),
                                                'slot-event-assigned':
                                                    event.studentID &&
                                                    !hasClass(event.section),
                                                'slot-event-unassigned': !event.studentID,
                                                'slot-event-inactive':
                                                    event.status == 'Inactive',
                                            }"
                                            v-on="on"
                                            v-html="event.title"
                                        ></div>
                                    </template>
                                    <v-card
                                        color="grey lighten-4"
                                        min-width="250px"
                                    >
                                        <div
                                            style="background-color: #4caf50; color: #fff;"
                                            class="pa-2"
                                        >
                                            {{ event.title }}
                                        </div>
                                        <div
                                            v-if="event.studentID"
                                            class="font-weight-regular title pa-2"
                                        >
                                            <div>
                                                {{ "טאטע: " + event.nameH }}
                                            </div>
                                            <div>
                                                {{ "קינד: " + event.hebName }}
                                            </div>
                                            <div
                                                class="font-weight-light body-2"
                                            >
                                                {{ event.address1 }}
                                            </div>
                                            <div
                                                v-if="event.homePhone"
                                                class="font-weight-light body-2"
                                            >
                                                {{ event.homePhone }}
                                            </div>
                                            <div
                                                v-if="event.cellPhone"
                                                class="font-weight-light body-2"
                                            >
                                                {{ event.cellPhone }}
                                            </div>
                                        </div>
                                        <div
                                            class="font-weight-regular title pa-2"
                                            v-if="!event.studentID"
                                        >
                                            Unassinged
                                        </div>
                                        <v-card-actions class="ml-2 pt-0">
                                            <v-btn small dark color="default">
                                                Close
                                            </v-btn>
                                            <v-btn
                                                small
                                                outline
                                                color="success"
                                                v-if="event.studentID"
                                                @click="
                                                    unassignAppointment(event)
                                                "
                                            >
                                                Unassign
                                            </v-btn>
                                            <v-btn
                                                small
                                                color="success"
                                                v-if="
                                                    !event.studentID &&
                                                        event.status !=
                                                            'Inactive'
                                                "
                                                @click="
                                                    openAssignAppointmentDialog(
                                                        event,
                                                    )
                                                "
                                            >
                                                Assign
                                            </v-btn>
                                            <v-btn
                                                small
                                                color="success"
                                                @click="
                                                    openUpdateAppointmentDialog(
                                                        event,
                                                    )
                                                "
                                            >
                                                Update / Delete
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-menu>
                            </template>
                        </template>
                    </v-calendar>
                </v-sheet>
            </v-flex>
        </div>
        <v-dialog persistent v-model="assignAppointment.dialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Assign Appointment</v-card-title
                >
                <v-layout row class="pa-0 mb-3" v-if="assignAppointment.slot">
                    <div class="mr-2">
                        {{ assignAppointment.slot.date | date }}
                    </div>
                    <div>{{ assignAppointment.slot.time }}</div>
                </v-layout>

                <v-select
                    label="Student"
                    :items="assignAppointment.studentListNames"
                    v-model="assignAppointment.student"
                ></v-select>

                <v-card-actions class="mx-0 px-2 pb-2 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="assignAppointment.dialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveAssigned()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="updateAppointment.dialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Update Appointment</v-card-title
                >
                <v-layout row class="pa-0 mb-3" v-if="updateAppointment.slot">
                    <div class="mr-2">
                        {{ updateAppointment.slot.date | date }}
                    </div>
                    <div>{{ updateAppointment.slot.time }}</div>
                </v-layout>

                <v-select
                    label="Status"
                    :items="['Active', 'Inactive']"
                    v-model="updateAppointment.status"
                    ref="status"
                    :rules="[rules.required]"
                ></v-select>

                <v-text-field
                    label="Duration"
                    v-model="updateAppointment.duration"
                    type="number"
                    ref="duration"
                    :rules="[rules.required, rules.min]"
                ></v-text-field>

                <v-card-actions class="mx-0 pb-2 mt-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateAppointment.dialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="warning"
                        @click="deleteSingleAppointment()"
                    >
                        Delete
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="updateSingleAppointment()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="addSlotsFromCalendarDialog"
            max-width="400"
        >
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Add Appointment Slots</v-card-title
                >
                <div class="mb-3">
                    <span class="mr-1 font-weight-medium">Date:</span>
                    {{ calendarClickedDate | date }}
                </div>

                <div v-if="!createAppointment.showCalendar">
                    <v-layout row class="mb-3">
                        <v-layout column align-start justify-start fill-height>
                            <v-layout row class="mb-3 time-list">
                                <div
                                    class="font-weight-regular mr-2 pt-3 width-100"
                                >
                                    From Time:
                                </div>
                                <DxDateBox
                                    style="height: 45px;"
                                    type="time"
                                    picker-type="list"
                                    :interval="15"
                                    v-model="createAppointment.timeFrom"
                                />
                            </v-layout>

                            <v-layout row class="time-list">
                                <div
                                    class="font-weight-regular mr-2 pt-3 width-100"
                                >
                                    To Time:
                                </div>
                                <DxDateBox
                                    style="height: 45px;"
                                    type="time"
                                    picker-type="list"
                                    :interval="15"
                                    v-model="createAppointment.timeTo"
                                />
                            </v-layout>

                            <div
                                v-if="
                                    calendarClickedDate &&
                                        getAppointmentForDate(
                                            calendarClickedDate,
                                        ).length
                                "
                                class="mt-4"
                                style="border: 2px solid #4caf50;"
                            >
                                <div
                                    class="font-weight-regular px-2 py-1"
                                    style="background-color: #4caf50; color: #fff;"
                                >
                                    {{ calendarClickedDate | date
                                    }}{{ " Appointments" }}
                                </div>
                                <v-divider></v-divider>
                                <div
                                    v-for="appointment in getAppointmentForDate(
                                        calendarClickedDate,
                                    )"
                                >
                                    <div class="mx-2">
                                        {{ appointment.time }}
                                    </div>
                                    <v-divider></v-divider>
                                </div>
                            </div>
                        </v-layout>
                    </v-layout>

                    <v-layout row class="mt-3">
                        <v-text-field
                            class="ml-1 mr-2"
                            v-model="createAppointment.duration"
                            label="Duration"
                            ref="duration"
                            type="number"
                            :rules="[rules.required, rules.min]"
                        ></v-text-field>

                        <v-select
                            label="Branch"
                            v-model="createAppointment.branch"
                            :items="createAppointment.branches"
                            class="mx-2"
                            @change="loadExistingAppointments"
                            ref="branch"
                            :rules="[rules.required]"
                            :disabled="hasUserBranch()"
                        >
                        </v-select>
                    </v-layout>
                </div>

                <div
                    v-if="createAppointment.showCalendar"
                    style="overflow-y: auto; height: 500px;"
                >
                    <template
                        v-if="eventsMap[calendarClickedDate].length"
                        v-for="event in eventsMap[calendarClickedDate]"
                    >
                        <v-menu
                            :key="event.title"
                            v-model="event.open"
                            full-width
                            offset-x
                        >
                            <template v-slot:activator="{ on }">
                                <div
                                    v-ripple
                                    class="slot-event slot-event-single-date"
                                    v-on="on"
                                    v-html="event.title"
                                ></div>
                            </template>
                        </v-menu>
                    </template>
                    <div
                        v-if="
                            !eventsMap[calendarClickedDate] ||
                                !eventsMap[calendarClickedDate].length
                        "
                        class="text-xs-center font-weight-medium"
                    >
                        No appointment slots available
                    </div>
                </div>

                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="
                            addSlotsFromCalendarDialog = false;
                            createAppointment.showCalendar = false;
                        "
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="default"
                        outline
                        v-if="createAppointment.showCalendar"
                        @click="createAppointment.showCalendar = false"
                        >Back</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        v-if="!createAppointment.showCalendar"
                        @click="loadAppoinments()"
                    >
                        Preview
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        outline
                        v-if="createAppointment.showCalendar"
                        :disabled="
                            !eventsMap[calendarClickedDate] ||
                                !eventsMap[calendarClickedDate].length
                        "
                        @click="save()"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="addSlotsDialog" max-width="800">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Add Appointment Slots</v-card-title
                >

                <div v-if="!createAppointment.showCalendar">
                    <v-layout row class="mb-3 mx-2">
                        <v-date-picker
                            style="border: 2px solid #4caf50; border-radius: unset;"
                            v-model="createAppointment.dates"
                            multiple
                            :allowedDates="allowedDates"
                            class="mr-4"
                            width="390"
                            :min="today"
                            :events="appointmentEvents"
                            @input="selectDate"
                        ></v-date-picker>

                        <v-layout column align-start justify-start fill-height>
                            <v-layout row class="mb-3 time-list">
                                <div
                                    class="font-weight-regular mr-2 pt-3 width-100"
                                >
                                    From Time:
                                </div>
                                <DxDateBox
                                    style="height: 45px;"
                                    type="time"
                                    picker-type="list"
                                    :interval="15"
                                    v-model="createAppointment.timeFrom"
                                />
                            </v-layout>

                            <v-layout row class="time-list">
                                <div
                                    class="font-weight-regular mr-2 pt-3 width-100"
                                >
                                    To Time:
                                </div>
                                <DxDateBox
                                    style="height: 45px;"
                                    type="time"
                                    picker-type="list"
                                    :interval="15"
                                    v-model="createAppointment.timeTo"
                                />
                            </v-layout>

                            <div
                                v-if="
                                    clickedDate &&
                                        getAppointmentForDate(clickedDate)
                                            .length
                                "
                                class="mt-4"
                                style="border: 2px solid #4caf50;"
                            >
                                <div
                                    class="font-weight-regular px-2 py-1"
                                    style="background-color: #4caf50; color: #fff;"
                                >
                                    {{ clickedDate | date
                                    }}{{ " Appointments" }}
                                </div>
                                <v-divider></v-divider>
                                <div
                                    v-for="appointment in getAppointmentForDate(
                                        clickedDate,
                                    )"
                                >
                                    <div class="mx-2">
                                        {{ appointment.time }}
                                    </div>
                                    <v-divider></v-divider>
                                </div>
                            </div>
                        </v-layout>
                    </v-layout>

                    <v-layout row class="mt-2">
                        <v-text-field
                            class="mx-2"
                            v-model="createAppointment.duration"
                            label="Duration"
                            ref="duration"
                            type="number"
                            :rules="[rules.required, rules.min]"
                        ></v-text-field>

                        <v-select
                            label="Branch"
                            v-model="createAppointment.branch"
                            :items="createAppointment.branches"
                            class="mx-2"
                            @change="loadExistingAppointments"
                            ref="branch"
                            :rules="[rules.required]"
                            :disabled="hasUserBranch()"
                        >
                        </v-select>
                    </v-layout>
                </div>

                <div
                    v-if="createAppointment.showCalendar"
                    style="overflow-y: auto; height: 500px;"
                >
                    <v-calendar
                        :now="today"
                        :value="today"
                        color="primary"
                        :min-weeks="createAppointment.minWeeks"
                    >
                        <template v-slot:day="{ date }">
                            <template
                                v-if="eventsMap[date].length"
                                v-for="event in eventsMap[date]"
                            >
                                <v-menu
                                    :key="event.title"
                                    v-model="event.open"
                                    full-width
                                    offset-x
                                >
                                    <template v-slot:activator="{ on }">
                                        <div
                                            v-ripple
                                            class="slot-event"
                                            v-on="on"
                                            v-html="event.title"
                                        ></div>
                                    </template>
                                </v-menu>
                            </template>
                        </template>
                    </v-calendar>
                </div>

                <v-card-actions class="mx-0 px-0 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="addSlotsDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="default"
                        outline
                        v-if="createAppointment.showCalendar"
                        @click="createAppointment.showCalendar = false"
                        >Back</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        v-if="!createAppointment.showCalendar"
                        @click="loadAppoinments()"
                    >
                        Preview
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        v-if="createAppointment.showCalendar"
                        @click="save()"
                    >
                        Save
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        v-if="createAppointment.showCalendar"
                        @click="save(true)"
                    >
                        Save & Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="deleteAppointmentsDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="text-warning headline"
                    >Are You Sure?</v-card-title
                >
                <v-card-text class="mb-3 py-0 title">
                    This will delete the selected appointments
                </v-card-text>
                <div
                    v-if="selected.some((s) => s.studentID)"
                    style="overflow-y: auto; height: 250px"
                >
                    <div
                        class="my-3 body-2 mx-3"
                        style="border-bottom: #4caf50 solid 2px;"
                    >
                        The following appointments are already assigned
                    </div>
                    <div
                        v-for="(appointment, index) in selected.filter(
                            (s) => s.studentID,
                        )"
                    >
                        <v-layout row justify-space-between class="px-3">
                            <div>
                                {{ appointment.date | date }}
                                {{ " " + appointment.time }}
                            </div>
                            <div>
                                {{ appointment.hebName }}
                            </div>
                        </v-layout>
                        <v-layout
                            row
                            justify-space-between
                            class="caption px-3 mt-1"
                        >
                            <div>
                                {{
                                    appointment.homePhone +
                                        (appointment.cellPhone
                                            ? " - " + appointment.cellPhone
                                            : "")
                                }}
                            </div>
                            <div>{{ " " + appointment.nameH }}</div>
                        </v-layout>
                        <v-divider class="my-1"></v-divider>
                    </div>
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteAppointmentsDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteAppointments()"
                        >Delete</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            persistent
            v-model="appointmentDurationDialog"
            max-width="400"
        >
            <v-card class="pa-2">
                <v-card-title class="headline pt-2"
                    >Update Appointment Duration</v-card-title
                >
                <v-text-field
                    label="Duration"
                    v-model="appointmentDuration"
                    type="number"
                    class="mx-3"
                    ref="appointmentDuration"
                    :rules="[rules.required, rules.min]"
                ></v-text-field>

                <v-card-actions class="mr-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="appointmentDurationDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="
                            updateAppointments({
                                appointmentDuration: appointmentDuration,
                            })
                        "
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="appointmentStatusDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline pt-2"
                    >Update Appointment Status</v-card-title
                >
                <v-select
                    label="Status"
                    v-model="appointmentStatus"
                    ref="appointmentStatus"
                    :rules="[rules.required]"
                    :items="['Active', 'Inactive']"
                    class="mx-3"
                ></v-select>

                <v-card-actions class="mr-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="appointmentStatusDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="
                            updateAppointments({
                                appointmentStatus: appointmentStatus,
                            })
                        "
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="blockedDatesDialog" max-width="600">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Blocked Dates</v-card-title
                >

                <v-layout row class="ml-3">
                    <v-btn
                        small
                        color="success"
                        class="mb-3"
                        @click="addBlockedDate"
                        >Add Blocked Date</v-btn
                    >
                    <v-btn
                        small
                        color="success"
                        class="mb-3 ml-2"
                        v-if="blockedDates.some((l) => l.selected)"
                        @click="deleteBlockedDates"
                        :loading="processing"
                        >Delete Blocked Dates</v-btn
                    >
                </v-layout>

                <div v-for="(blockDate, index) in newBlockedDates">
                    <v-layout row class="pa-0 ml-3 mb-0">
                        <v-menu
                            v-model="blockDate.datePickerMenu"
                            :close-on-content-click="true"
                            offset-y
                            full-width
                            prepend-icon="mdi-currency-usd"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="blockDate.date"
                                    :value="blockDate.date"
                                    label="Date"
                                    prepend-icon="mdi-calendar"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="blockDate.date"
                            ></v-date-picker>
                        </v-menu>
                        <v-text-field
                            class="width-200 mx-2"
                            v-model="blockDate.note"
                            label="Note"
                        ></v-text-field>

                        <v-btn
                            @click="addBlockedDate"
                            flat
                            icon
                            color="success"
                        >
                            <v-icon>mdi-plus-circle</v-icon>
                        </v-btn>
                        <v-btn
                            @click="removeBlockedDate(index)"
                            flat
                            icon
                            color="#f55a4e"
                        >
                            <v-icon>mdi-minus-circle-outline</v-icon>
                        </v-btn>
                    </v-layout>
                </div>
                <v-btn
                    color="success"
                    small
                    class="ml-3 mt-0 mb-4"
                    :loading="processing"
                    @click="saveNewBlockedDate"
                    v-if="newBlockedDates.length"
                    >Save</v-btn
                >

                <v-divider class="pb-0 pt-3"></v-divider>
                <div style="height: 450px; overflow-y: auto;">
                    <div v-for="(blockedDate, index) in blockedDates">
                        <v-layout column class="pa-0 ml-3 mb-0">
                            <v-layout row>
                                <v-checkbox
                                    class="width-50 my-0"
                                    hide-details
                                    v-model="blockedDate.selected"
                                    color="success"
                                ></v-checkbox>

                                <div class="width-120 pt-1">
                                    {{ blockedDate.date | date }}
                                </div>
                                <div class="pt-1 width-120">
                                    Branch: {{ blockedDate.branch }}
                                </div>
                                <div class="pt-1">{{ blockedDate.note }}</div>
                            </v-layout>
                        </v-layout>
                        <v-divider
                            class="pb-0 pt-3"
                            v-if="index + 1 < blockedDates.length"
                        ></v-divider>
                    </div>
                </div>
                <v-card-actions class="mx-0 px-2 pb-2 mt-2">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="blockedDatesDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import moment from "moment";
import "devextreme/dist/css/dx.light.css";
import { groupBy } from "../../utils/helpers.js";
import DxDateBox from "devextreme-vue/date-box";
import * as Hebcal from "hebcal";

export default {
    components: {
        DxDateBox,
    },
    data: () => ({
        title: "Apointments",

        viewMode: "calendar",

        listURL: "",

        actions: [],

        items: [
            { title: "Click Me" },
            { title: "Click Me" },
            { title: "Click Me" },
            { title: "Click Me 2" },
        ],

        addSlotsDialog: false,
        deleteAppointmentsDialog: false,
        addSlotsFromCalendarDialog: false,

        appointmentDurationDialog: false,
        appointmentDuration: "",
        appointmentStatusDialog: false,
        appointmentStatus: "",
        processing: false,

        branches: [],

        today: new Date().toISOString().substr(0, 10),
        now: new Date(),

        existingAppointments: [],
        appointmentEvents: null,
        clickedDate: "",
        calendarClickedDate: "",
        selectedDates: [],
        userBranch: "",
        selected: [],
        blockedDatesDialog: false,
        newBlockedDates: [],
        blockedDates: [],
        regID: "",
        terms: [],

        start: moment().format("YYYY-MM-DD"),
        end: moment()
            .add(10, "day")
            .format("YYYY-MM-DD"),

        createAppointment: {
            dateFromPickerMenu: false,
            dateFrom: "",
            dateToPickerMenu: false,
            dateTo: "",
            timeFromPickerMenu: false,
            timeFrom: new Date(),
            timeToPickerMenu: false,
            timeTo: new Date(),
            duration: 15,
            dates: [],

            showCalendar: false,
            minWeeks: 5,
            slots: [],
            branch: "",
            branches: [],

            minDateTo: new Date().toISOString().substr(0, 10),
            maxDateFrom: "",
        },

        assignAppointment: {
            slot: "",
            studentList: [],
            studentListNames: [],
            student: "",
            dialog: false,
        },

        updateAppointment: {
            slot: "",
            status: "",
            duration: "",
            dialog: false,
        },

        columns: [
            {
                label: "Date",
                field: "date",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Time",
                field: "time",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Duration",
                field: "duration",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Branch",
                field: "branch",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Section",
                field: "section",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student ID",
                field: "studentID",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Family ID",
                field: "familyID",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Name",
                field: "engName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Student Hebrew",
                field: "hebName",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name Hebrew",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered By",
                field: "enteredBy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Entered On",
                field: "enteredOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date Sort",
                field: "dateSort",
                visible: false,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Time Sort",
                field: "timeSort",
                visible: false,
                //type: "time",
                //format: "hh:mm:ss a",
                sortOrder: "asc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        date: "",
        intervalID: "",

        rules: {
            required: (value) => !!value || "Required.",
            min: (value) => {
                return !value || value > 0 || "Duration Required";
            },
        },
    }),
    computed: {
        eventsMap() {
            const map = {};
            this.createAppointment.slots.forEach((e) =>
                (map[e.date] = map[e.date] || []).push(e),
            );
            return map;
        },
        existingEventsMap() {
            const map = {};
            this.existingAppointments.forEach((e) =>
                (map[e.date] = map[e.date] || []).push(e),
            );
            return map;
        },
    },
    mounted() {},
    beforeDestroy() {},
    async created() {
        this.actions.push({
            text: "Add Appointment Slots",
            action: this.addSlots,
        });

        this.actions.push({
            text: "Update Appointment Duration",
            action: this.openUpdateAppointmentDurationDialog,
            showOnSelection: true,
        });

        this.actions.push({
            text: "Update Appointment Status",
            action: this.openUpdateAppointmentStatusDialog,
            showOnSelection: true,
        });

        this.actions.push({
            text: "Delete Appointments",
            action: this.openDeleteAppointmentsDialog,
            showOnSelection: true,
        });

        this.loadBranches();
        this.loadTerms();

        await this.loadRegID();

        const branch = this.$store.state.authentication.branch;

        this.userBranch = branch;
        this.createAppointment.branch = branch ? branch.split(",")[0] : "SEL";

        this.setTime();

        await this.loadExistingAppointments();
        await this.loadBlockedDates();

        this.listURL =
            "appointments?source=590&regID=" +
            this.regID +
            (this.userBranch != "null"
                ? "&branch=" + this.userBranch
                : "&branch=");
    },
    methods: {
        allowChangingAppointment() {
            const roles = Array.isArray(this.$store.state.authentication.roles)
                ? this.$store.state.authentication.roles
                : this.$store.state.authentication.roles
                ? this.$store.state.authentication.roles.split(",")
                : [];

            return roles.includes("Appointment Admin");
        },
        openBlockedDatesDialog() {
            this.blockedDatesDialog = true;
        },
        async onRowClicked(row) {},
        onGridCellPrepared(e) {
            if (e.rowType != "data" || !e.data || !e.cellElement) return;

            const rowElement = e.cellElement.parentElement;

            if (!rowElement) return;

            if (this.isPacificSummerSection(e.data.section)) {
                rowElement.style.setProperty(
                    "background-color",
                    "#efe1ff",
                    "important",
                );
                rowElement.style.setProperty("color", "#4a257c", "important");
            } else {
                rowElement.style.removeProperty("background-color");
                rowElement.style.removeProperty("color");
            }
        },
        hasUserBranch() {
            return this.userBranch &&
                this.userBranch != "null" &&
                !this.userBranch.includes(",")
                ? true
                : false;
        },
        async loadTerms() {
            const response = await this.$http.get(
                "api/allStudents/getRegTerms",
            );

            this.terms = response;
        },
        async loadRegID() {
            this.regID = await this.$http.get(
                "api/NotAssinedStudents/getRegID",
            );
        },
        async loadAppoinments() {
            if (
                !this.$refs.duration.validate(true) ||
                !this.$refs.branch.validate(true)
            )
                return;

            if (!this.createAppointment.dates.length) {
                return this.$notify({
                    text: "No Dates Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (!this.createAppointment.dates.length) {
                return this.$notify({
                    text: "No Dates Selected",
                    group: "notification",
                    type: "error",
                });
            }

            if (this.invalidTimes()) {
                return this.$notify({
                    text: this.invalidTimes(),
                    group: "notification",
                    type: "error",
                });
            }

            // if (this.hasScheduledAppointments()) {
            //     return this.$notify({
            //         text:
            //             "There are scheduled appointments for the selected times",
            //         group: "notification",
            //         type: "error",
            //     });
            // }

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/appointments/GetAppointmentSlots",
                    {
                        user: this.$store.state.authentication.user,
                        dates: this.createAppointment.dates,
                        timeFrom: moment(
                            this.createAppointment.timeFrom,
                        ).format("HH:mm:ss"),
                        timeTo: moment(this.createAppointment.timeTo).format(
                            "HH:mm:ss",
                        ),
                        duration: this.createAppointment.duration,
                        source: "590",
                    },
                );

                this.processing = false;

                this.createAppointment.slots = response.map((slot) => {
                    slot.open = false;
                    slot.title = slot.time;
                    slot.details = "";
                    slot.date = moment(slot.date).format("YYYY-MM-DD");

                    return slot;
                });

                this.createAppointment.minWeeks = this.getMinWeeks();

                this.createAppointment.showCalendar = true;
            } catch (e) {
                this.processing = false;
            }
        },
        invalidTimes() {
            let invalid =
                this.createAppointment.timeFrom ==
                    this.createAppointment.timeTo ||
                this.createAppointment.timeTo < this.createAppointment.timeFrom;

            if (invalid) return "Selected times are incorrect. Please Fix";

            const diffInMinutes = moment(this.createAppointment.timeTo).diff(
                this.createAppointment.timeFrom,
                "minutes",
            );

            return diffInMinutes < this.createAppointment.duration
                ? "Insufficient time for duration of appointment. Please change time"
                : "";
        },
        async loadBlockedDates() {
            this.blockedDates = await this.$http.get(
                "api/appointments/GetBlockedDates?source=590",
            );
        },
        async regIDChanged(value) {
            await this.loadExistingAppointments();
            this.loadNotAssignedStudents();

            this.listURL =
                "appointments?source=590&regID=" +
                this.regID +
                "&branch=" +
                this.createAppointment.branch;

            if (this.$refs.grid) {
                this.$refs.grid.reloadDataSource(this.listURL);
            }
        },
        async branchChanged(value) {
            await this.loadExistingAppointments();
            this.loadNotAssignedStudents();

            // this.listURL =
            //     "appointments?regID=" +
            //     this.regID + "&branch=" + this.createAppointment.branch;

            // if (this.$refs.grid) {
            //     this.$refs.grid.reloadDataSource(this.listURL);
            // }
        },
        async loadExistingAppointments() {
            const appointments = await this.$http.get(
                "api/appointments/loadExistingAppointments?source=590&branch=" +
                    this.createAppointment.branch +
                    "&regID=" +
                    this.regID +
                    "&onlyFutureDate=false",
            );

            this.existingAppointments = appointments.map((appointment) => {
                appointment.date = moment(appointment.date).format(
                    "YYYY-MM-DD",
                );

                appointment.title =
                    appointment.time +
                    (appointment.studentID
                        ? " - " +
                          appointment.hebName +
                          " " +
                          appointment.lastNameH
                        : "");
                appointment.open = false;

                return appointment;
            });

            this.appointmentEvents = Object.keys(
                groupBy(this.existingAppointments, "date"),
            ).map((key) => {
                const date = new Date(key);
                return date.toISOString().substr(0, 10);
            });
        },
        async loadBranches() {
            const branches = await this.$http.get("api/students/getBranchList");

            this.createAppointment.branches = branches.filter(Boolean).sort();

            if (this.userBranch && this.userBranch != "null") {
                this.createAppointment.branches = this.userBranch.split(",");
            }
        },
        selectDate(value) {
            this.clickedDate = value.find(
                (date) => !this.selectedDates.some((sd) => sd == date),
            );

            this.selectedDates = value;
        },
        getAppointmentForDate(date) {
            return this.existingAppointments.filter((e) => e.date == date);
        },
        isBlocked(date) {
            return this.blockedDates.some(
                (b) =>
                    moment(b.date).format("L") == moment(date).format("L") &&
                    b.branch == this.createAppointment.branch,
            );
        },
        getDateInfo(date) {
            if (this.isBlocked(date)) return "Private Appointment";

            const parsedDate = new Date(date + "T00:00:00");

            if (parsedDate.getDay() == 6) return "";

            const hebDate = new Hebcal.HDate(parsedDate);

            const month = this.getMonthNumber(hebDate.month, hebDate.year);
            const day = hebDate.day;

            return this.isHoliday(month, day, hebDate.year)
                ? this.getHoliday(month, day, hebDate.year)
                : "";
        },
        isFirstOfMonth(date) {
            const isFirstOfMonth = +date.split("-")[2] == 1;

            return isFirstOfMonth;
        },
        allowedDates(date) {
            const parsedDate = new Date(date + "T00:00:00");

            if (parsedDate.getDay() == 6) return false;

            const hebDate = new Hebcal.HDate(parsedDate);

            const month = this.getMonthNumber(hebDate.month, hebDate.year);
            const day = hebDate.day;

            return !this.isHoliday(month, day, hebDate.year);
        },
        // isHoliday(month, dayInMonth, year) {
        //     switch (`${month}-${dayInMonth}`) {
        //         case "1-1": //Rosh hashana day 1
        //         case "1-2": //Rosh hashana day 2
        //         case "1-9": //Yom kipur
        //         case "1-10": //Yom kipur
        //         case "1-14": //Erev Succos
        //         case "1-15": //Succos day 1
        //         case "1-16": //succos day 2
        //         case "1-17": //succos day 3
        //         case "1-18": //succos day 4
        //         case "1-19": //succos day 5
        //         case "1-20": //succos day 6
        //         case "1-21": //succos day 7
        //         case "1-22": //shmini atzeres:
        //         case "1-23": //simchas Torah
        //         case "7-15": //passover day 1 or shushan purim (leap year)
        //             return true;

        //         //non leap year:
        //         case "6-14": //purim
        //         case "6-15": //shushan purim
        //         case "7-16": //passover day 2
        //         case "7-17": //passover day 3
        //         case "7-18": //passover day 4
        //         case "7-19": //passover day 5
        //         case "7-20": //passover day 6
        //         case "7-21": //shviei shel pesach
        //         case "7-22": //achron shel pesach
        //         case "9-6": //shvous day 1
        //         case "9-7": //shvuos day 2
        //         case "11-9": //tishu be-av
        //             if (!this.isLeapYearHe(year)) return true;
        //             return false;

        //         //leap year
        //         case "7-14": //purim
        //         case "8-14": //erev passover
        //         case "8-15": //passover day 1
        //         case "8-16": //passover day 2
        //         case "8-17": //passover day 3
        //         case "8-18": //passover day 4
        //         case "8-19": //passover day 5
        //         case "8-20": //passover day 6
        //         case "8-21": //shviei shel pesach
        //         case "8-22": //achron shel pesach
        //         case "10-6": //shvous day 1
        //         case "10-7": //shvuos day 2
        //         case "12-9": //tishu be-av
        //             return true;

        //         default:
        //             return false;
        //     }
        // },
        isHoliday(month, dayInMonth, year) {
            // Ensure inputs are integers
            month = parseInt(month);
            dayInMonth = parseInt(dayInMonth);
            year = parseInt(year);

            const isLeap = this.isLeapYearHe(year);
            const dateStr = `${month}-${dayInMonth}`;

            // Holidays in Tishrei (month 1) - same every year
            const tishreiHolidays = [
                "1-1", // Rosh Hashanah Day 1
                "1-2", // Rosh Hashanah Day 2
                "1-9", // Yom Kippur
                "1-10", // Yom Kippur
                "1-14", // Erev Sukkot
                "1-15", // Sukkot Day 1
                "1-16", // Sukkot Day 2
                "1-17", // Sukkot Day 3
                "1-18", // Sukkot Day 4
                "1-19", // Sukkot Day 5
                "1-20", // Sukkot Day 6
                "1-21", // Sukkot Day 7
                "1-22", // Shmini Atzeret
                "1-23", // Simchat Torah
            ];

            // Non-leap year holidays
            const nonLeapHolidays = [
                "6-14", // Adar II: Purim
                "6-15", // Adar II: Shushan Purim
                "7-15", // Nisan: Passover Day 1
                "7-16", // Passover Day 2
                "7-17", // Passover Day 3
                "7-18", // Passover Day 4
                "7-19", // Passover Day 5
                "7-20", // Passover Day 6
                "7-21", // Shvi’i shel Pesach
                "7-22", // Acharon shel Pesach
                "9-6", // Sivan: Shavuot Day 1
                "9-7", // Shavuot Day 2
                "11-9", // Av: Tisha B’Av
            ];

            // Leap year holidays
            const leapHolidays = [
                "7-14", // Adar II: Purim
                "7-15", // Adar II: Shushan Purim
                "8-14", // Nisan: Erev Passover
                "8-15", // Passover Day 1
                "8-16", // Passover Day 2
                "8-17", // Passover Day 3
                "8-18", // Passover Day 4
                "8-19", // Passover Day 5
                "8-20", // Passover Day 6
                "8-21", // Shvi’i shel Pesach
                "8-22", // Acharon shel Pesach
                "10-6", // Sivan: Shavuot Day 1
                "10-7", // Shavuot Day 2
                "12-9", // Av: Tisha B’Av
            ];

            // Check Tishrei holidays (same regardless of leap year)
            if (tishreiHolidays.includes(dateStr)) {
                return true;
            }

            // Check leap vs non-leap holidays
            if (isLeap) {
                return leapHolidays.includes(dateStr);
            } else {
                return nonLeapHolidays.includes(dateStr);
            }
        },
        isLeapYearHe(year) {
            const leapYears = [0, 3, 6, 8, 11, 14, 17];
            const yearInCycle = year % 19;
            return leapYears.includes(yearInCycle);
        },
        getMonthNumber(month, year) {
            const isLeapYear = this.isLeapYearHe(year);

            switch (month) {
                case 7:
                    return 1;
                case 8:
                    return 2;
                case 9:
                    return 3;
                case 10:
                    return 4;
                case 11:
                    return 5;
                case 12:
                    return 6;
                case 13:
                    return 7;
                case 1:
                    return isLeapYear ? 8 : 7;
                case 2:
                    return isLeapYear ? 9 : 8;
                case 3:
                    return isLeapYear ? 10 : 9;
                case 4:
                    return isLeapYear ? 11 : 10;
                case 5:
                    return isLeapYear ? 12 : 11;
                case 6:
                    return isLeapYear ? 13 : 12;
            }
        },
        getHoliday(month, dayInMonth, year) {
            const isLeapYear = this.isLeapYearHe(year);

            switch (`${month}-${dayInMonth}`) {
                case "1-1":
                    return "Rosh Hashana Day 1";
                case "1-2":
                    return "Rosh Hashana Day 2";
                case "1-9":
                    return "Erev Yom kipur";
                case "1-10":
                    return "Yom kipur";
                case "1-14":
                    return "Erev Succos";
                case "1-15":
                    return "Succos Day 1";
                case "1-16":
                    return "Succos Day 2";
                case "1-17":
                    return "Succos Day 3";
                case "1-18":
                    return "Succos Day 4";
                case "1-19":
                    return "Succos Day 5";
                case "1-20":
                    return "Succos Day 6";
                case "1-21":
                    return "Succos Day 7";
                case "1-22":
                    return "Shmini Atzeres:";
                case "1-23":
                    return "Simchas Torah";
                case "7-15":
                    return !this.isLeapYearHe(year)
                        ? "Passover Day 1"
                        : "Shushan Purim";
                    return true;

                //non leap year:
                case "6-14":
                    return "Purim";
                case "6-15":
                    return "Shushan Purim";
                case "7-16":
                    return "Passover day 2";
                case "7-17":
                    return "Passover day 3";
                case "7-18":
                    return "Passover day 4";
                case "7-19":
                    return "Passover day 5";
                case "7-20":
                    return "Passover day 6";
                case "7-21":
                    return "Shviei shel pesach";
                case "7-22":
                    return "Achron shel pesach";
                case "9-6":
                    return "Shvous Day 1";
                case "9-7":
                    return "Shvuos Day 2";
                case "11-9":
                    return "Tishu Be-Av";
                    if (!this.isLeapYearHe(year)) return true;
                //return false;

                //leap year
                case "7-14":
                    return isLeapYear ? "Purim" : "";
                case "8-14":
                    return isLeapYear ? "Erev Passover" : "";
                case "8-15":
                    return isLeapYear ? "Passover Day 1" : "";
                case "8-16":
                    return isLeapYear ? "Passover Day 2" : "";
                case "8-17":
                    return isLeapYear ? "Passover Day 3" : "";
                case "8-18":
                    return isLeapYear ? "Passover Day 4" : "";
                case "8-19":
                    return isLeapYear ? "Passover Day 5" : "";
                case "8-20":
                    return isLeapYear ? "Passover Day 6" : "";
                case "8-21":
                    return isLeapYear ? "Shviei Shel Pesach" : "";
                case "8-22":
                    return isLeapYear ? "Achron Shel Pesach" : "";
                case "10-6":
                    return isLeapYear ? "Shvous Day 1" : "";
                case "10-7":
                    return isLeapYear ? "Shvuos Day 2" : "";
                case "12-9":
                    return isLeapYear ? "Tishu Be-Av" : "";
                    return true;

                default:
                    return false;
            }
        },
        getCurrentMonth() {
            return moment(this.start)
                .format("MMMM")
                .toUpperCase();
        },
        getMinWeeks() {
            const minDate = new Date();

            const maxDate = moment.max(
                this.createAppointment.slots.map((s) => moment(s.date)),
            );

            return moment(maxDate).diff(minDate, "week") + 4;
        },
        hasScheduledAppointments() {
            return this.createAppointment.dates.some((date) => {
                const existing = this.getAppointmentForDate(date);

                const timeFrom = moment(this.createAppointment.timeFrom).format(
                    "HH:mm",
                );
                const timeTo = moment(this.createAppointment.timeTo).format(
                    "HH:mm",
                );

                const timeFromDate = moment(
                    moment(date).format("YYYY-MM-DD") + " " + timeFrom,
                ).toDate();
                const timeToDate = moment(
                    moment(date).format("YYYY-MM-DD") + " " + timeTo,
                ).toDate();

                return existing.some((e) => {
                    const exitingTime = moment(
                        moment(date).format("YYYY-MM-DD") + " " + e.time,
                    ).toDate();

                    e.duration;

                    return (
                        exitingTime >= timeFromDate && exitingTime < timeToDate
                    );
                });
            });
        },

        saveTime(value, type) {
            if (type == "from") {
                this.$refs.timeFrom.save(value);
            } else {
                this.$refs.timeTo.save(value);
            }
        },
        async deleteBlockedDates() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/appointments/deleteBlockDates",
                    this.blockedDates
                        .filter((d) => d.selected)
                        .map((blockedDate) => blockedDate.id),
                );

                this.loadBlockedDates();
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        addBlockedDate() {
            this.newBlockedDates.push({
                date: "",
                note: "",
                datePickerMenu: false,
            });
        },
        removeBlockedDate(index) {
            this.newBlockedDates.splice(index, 1);
        },
        async saveNewBlockedDate() {
            try {
                if (this.newBlockedDates.some((b) => !b.date)) {
                    return this.$notify({
                        text: "Date Required",
                        group: "notification",
                        type: "error",
                    });
                }

                if (this.newBlockedDates.some((b) => !b.note)) {
                    return this.$notify({
                        text: "Note Required",
                        group: "notification",
                        type: "error",
                    });
                }

                this.processing = true;

                const today = moment().format("YYYY-MM-DD HH:mm:ss");

                await this.$http.post(
                    "api/appointments/saveBlockDates",
                    this.newBlockedDates.map((blockedDate) => ({
                        date: blockedDate.date,
                        note: blockedDate.note,
                        enteredBy: this.$store.state.authentication.user,
                        enteredAt: today,
                        branch: this.createAppointment.branch,
                        source: "590",
                    })),
                );

                this.loadBlockedDates();
                this.newBlockedDates = [];
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        changeMinFrom(value) {
            this.createAppointment.maxDateFrom = value;
        },
        changeMinTo(value) {
            this.createAppointment.minDateTo = value;
        },
        openDeleteAppointmentsDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.deleteAppointmentsDialog = true;
        },
        openUpdateAppointmentDurationDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.appointmentDurationDialog = true;
        },
        openUpdateAppointmentStatusDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.appointmentStatusDialog = true;
        },
        async updateAppointments({ appointmentDuration, appointmentStatus }) {
            try {
                this.processing = true;

                const ids = this.selected.map((s) => s.id);

                const response = await this.$http.post(
                    "api/appointments/updateAppointments",
                    {
                        ids,
                        status: appointmentStatus,
                        duration: appointmentDuration,
                    },
                );

                this.appointmentDurationDialog = false;
                this.appointmentStatusDialog = false;

                this.processing = false;

                if (this.$refs.grid) {
                    this.$refs.grid.reloadGrid();
                }

                this.loadExistingAppointments();
            } catch (e) {
                this.processing = false;
            }
        },
        async deleteAppointments() {
            try {
                this.processing = true;

                const ids = this.selected.map((s) => s.id);

                const response = await this.$http.post(
                    "api/appointments/deleteAppointments",
                    ids,
                );

                this.deleteAppointmentsDialog = false;

                this.processing = false;

                if (this.$refs.grid) {
                    this.$refs.grid.reloadGrid();
                }

                this.loadExistingAppointments();
            } catch (e) {
                this.processing = false;
            }
        },
        async save(shouldClose = false) {
            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/appointments/SaveAppointments",
                    this.createAppointment.slots.map((appointment) => {
                        appointment.branch = this.createAppointment.branch;
                        appointment.source = "590";

                        return appointment;
                    }),
                );

                if (shouldClose) {
                    this.addSlotsDialog = false;
                }

                this.addSlotsFromCalendarDialog = false;

                this.processing = false;

                this.$notify({
                    text: "Appointments Saved",
                    group: "notification",
                    type: "success",
                });

                this.reset(shouldClose);

                if (this.$refs.grid) {
                    this.$refs.grid.reloadGrid();
                }

                this.loadExistingAppointments();
            } catch (e) {
                this.processing = false;
            }
        },
        reset(shouldClose = true) {
            if (shouldClose) {
                this.createAppointment.dateFromPickerMenu = false;
                this.createAppointment.dateFrom = "";
                this.createAppointment.dateToPickerMenu = false;
                this.createAppointment.dateTo = "";
                this.createAppointment.dates = [];
                this.createAppointment.timeFromPickerMenu = false;
                this.createAppointment.timeToPickerMenu = false;
            }

            this.createAppointment.duration = 15;
            this.createAppointment.showCalendar = false;
            this.createAppointment.minWeeks = 5;
            this.createAppointment.slots = [];
            this.createAppointment.minDateTo = new Date()
                .toISOString()
                .substr(0, 10);
            this.createAppointment.maxDateFrom = "";

            this.setTime();

            this.assignAppointment.student = "";
            this.assignAppointment.slot = "";
            this.assignAppointment.dialog = false;
        },
        setTime() {
            const timeFrom = moment().toDate();

            timeFrom.setHours(12);
            timeFrom.setMinutes(0);
            timeFrom.setSeconds(0);
            timeFrom.setMilliseconds(0);

            this.createAppointment.timeFrom = timeFrom;

            const timeTo = moment().toDate();

            timeTo.setHours(14);
            timeTo.setMinutes(0);
            timeTo.setSeconds(0);
            timeTo.setMilliseconds(0);

            this.createAppointment.timeTo = timeTo;
        },
        addSlots() {
            this.addSlotsDialog = true;
        },
        addSlotsFromCalendar(date) {
            this.calendarClickedDate = date;
            this.createAppointment.dates = [date];
            this.addSlotsFromCalendarDialog = true;
        },
        async unassignAppointment(appointment) {
            try {
                this.processing = true;

                appointment.studentID = null;
                appointment.familyID = null;
                appointment.source = "590";

                await this.$http.post("api/appointments/save", appointment);

                this.processing = false;

                this.reset();

                this.loadExistingAppointments();

                if (this.$refs.grid) {
                    this.$refs.grid.reloadGrid();
                }
            } catch (e) {
                this.processing = false;
            }
        },
        async loadNotAssignedStudents() {
            const response = await this.$http.get(
                "odata/notAssinedStudents?date=&regID=" +
                    this.regID +
                    "&branch=",
                //+this.createAppointment.branch,
            );

            this.assignAppointment.studentList = response.value
                .map((student) => {
                    student.displayName =
                        student.hebName +
                        " " +
                        student.lastNameH +
                        ' ב"' +
                        student.fatherH;

                    return student;
                })
                .filter((s) => !s.appointmentDate);
            this.assignAppointment.studentListNames = this.assignAppointment.studentList.map(
                (student) => {
                    return student.displayName;
                },
            );
        },
        openAssignAppointmentDialog(event) {
            this.assignAppointment.slot = event;

            this.loadNotAssignedStudents();

            this.assignAppointment.dialog = true;
        },
        openUpdateAppointmentDialog(event) {
            this.updateAppointment.slot = event;
            this.updateAppointment.duration = event.duration;
            this.updateAppointment.status = event.status
                ? event.status
                : "Active";

            this.updateAppointment.dialog = true;
        },
        async deleteSingleAppointment() {
            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/appointments/deleteAppointments",
                    [this.updateAppointment.slot.id],
                );

                this.updateAppointment.dialog = false;

                this.processing = false;

                if (this.$refs.grid) {
                    this.$refs.grid.reloadGrid();
                }

                this.loadExistingAppointments();
            } catch (e) {
                this.processing = false;
            }
        },
        async updateSingleAppointment() {
            if (
                !this.$refs.duration.validate(true) ||
                !this.$refs.status.validate(true)
            )
                return;

            if (
                !this.updateAppointment.duration ||
                this.updateAppointment.duration == 0
            ) {
                return this.$notify({
                    text: "Duration is Required",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const response = await this.$http.post(
                    "api/appointments/updateAppointments",
                    {
                        ids: [this.updateAppointment.slot.id],
                        status: this.updateAppointment.status,
                        duration: this.updateAppointment.duration,
                    },
                );

                this.updateAppointment.dialog = false;

                this.processing = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                if (this.$refs.grid) {
                    this.$refs.grid.reloadGrid();
                }

                this.loadExistingAppointments();
            } catch (e) {
                this.processing = false;
            }
        },
        hasClass(section) {
            return section != "0" && section != "X0";
        },
        isPacificSummerSection(section) {
            return section == "0R";
        },
        async saveAssigned() {
            if (!this.assignAppointment.student) {
                return this.$notify({
                    text: "No Student Selected",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const student = this.assignAppointment.studentList.find(
                    (s) => s.displayName == this.assignAppointment.student,
                );

                const appointment = JSON.parse(
                    JSON.stringify(this.assignAppointment.slot),
                );

                appointment.studentID = student.studentID;
                appointment.familyID = student.familyID;
                appointment.source = "590";

                await this.$http.post("api/appointments/save", appointment);

                this.processing = false;

                this.reset();

                this.loadExistingAppointments();

                if (this.$refs.grid) {
                    this.$refs.grid.reloadGrid();
                }
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style lang="stylus" scoped>
.gray-fg {
    color: #999;
}
.add-slots-button {
    top: 0 !important;
    right: 0px !important;
    position: absolute !important;
    padding-top: 0px !important;
    margin-top: 0px !important;
    padding-bottom: 10px !important;
}
.heb-date {
    top: 0 !important;
    left: 36px !important;
    position: absolute !important;
    padding-top: 4px !important;
    margin-top: 0px !important;
    padding-bottom: 0px !important;
}
.left-68 {
    left: 68px !important;
}
.slot-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    color: #ffffff;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    margin-bottom: 1px;
    background-color: #30a635;
  }
  .slot-event-single-date {
    font-size: 15px !important;
    margin-bottom: 3px !important;
  }
  .slot-event-clickable {
    cursor: pointer;
  }
  .slot-event-assigned {
    background-color: #00d3ee !important;
  }
  .slot-event-assigned-class {
        background-color: #f6f6bd !important;
    color: #c73420;;
  }
  .slot-event-unassigned {
    background-color: #b9b0b0 !important;
  }
  .slot-event-inactive {
    background-color: #d56969 !important;
  }
  .time-list .dx-texteditor.dx-state-focused.dx-editor-outlined {
    border-color: #30a635 !important;
  }
  .time-list .dx-texteditor.dx-state-hover {
    border-color: #30a635 !important;
  }
.appointments-mode-toggle-button {
    font-size: 15px;
    padding: 5px !important;
    border-radius: 15px;
}
.appointments-mode-toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #dcdfe6;
    border: none !important;
}
</style>
